import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {Office} from '../classes/Office';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class OfficeService {

  constructor(private httpClient: HttpClient) { }

  public getAll(): Observable<Office[]> {
    return this.httpClient.get<Office[]>(`${environment.backendApiUrl}/v1/offices`, httpOptions);
  }

  public officeInfo(id: number): Observable<Office> {
    return this.httpClient.get<Office>(`${environment.backendApiUrl}/v1/offices/` + id, httpOptions);
  }

  public addOrEdit(office: Office): Observable<void> {
    return this.httpClient.put<void>(`${environment.backendApiUrl}/v1/offices`, office, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/offices/` + id, httpOptions);
  }
}
